import {
  IconBell,
  IconMenu2,
  IconQuestionMark,
  IconSearch,
} from '@tabler/icons-react'
import styles from '../../styles/common/MainHeader.module.scss'
import Profile from './Profile'
import SearchInput from './SearchInput'
import { Icon } from '../../assets/icons'

interface MainHeaderProps {
  onToggleSidebar?: () => void
  isStudent?: boolean
}

const MainHeader = ({ onToggleSidebar, isStudent }: MainHeaderProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftWrapper}>
        <div
          className={`${styles.menuIcon} ${isStudent ? styles.menuIconStudent : ''}`}
          onClick={onToggleSidebar}
        >
          <IconMenu2 size={24} stroke={isStudent ? 2 : 1.5} />
        </div>
        <a href="/dashboard">
          <img
            src="/assets/blue-logo.svg"
            alt="Blue Logo"
            className={styles.logo}
          />
        </a>
      </div>
    </div>
  )
}

export default MainHeader
